import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { notification } from "antd";
import OneSignal from "react-onesignal";
// import mixpanel from "mixpanel-browser";
import { user_token } from "./_helpers/tokensStored";
import PrivateRoute from "./_helpers/PrivateRoute";
import PublicRoute from "./_helpers/PublicRoute";
import SignIn from "./_components/Common/SignIn";
import SignUp from "./_components/Common/SignUp";
import ForgotPassword from "./_components/Common/ForgotPassword";
import ResetPassword from "./_components/Common/ResetPassword";
import RoleSelection from "./_components/Common/RoleSelection";
import HiringManagerOnboard from "./_components/HiringManager/HiringManagerOnboard";
import HiringManagerOnboardSuccesful from "./_components/HiringManager/HiringManagerOnboardSuccesful";
import HiringManagerKanboard from "./_components/HiringManager/HiringManagerKanboard";
import HiringManagerCreateJob from "./_components/HiringManager/HiringManagerCreateJob";
import HiringProcessDashboard from "./_components/HiringManager/HiringProcessDashboard";
import ViewAssessmentVideo from "./_components/Common/ViewAssessmentVideo";
// import CandidateDashboard from "./_components/Candidate/CandidateDashboard";
import CandidateDetails from "./_components/Candidate/CandidateDetails";
import CandidateOnboardSuccessful from "./_components/Candidate/CandidateOnboardSuccessful/CandidateOnboardSuccessful";
import HiringManagerRoute from "./_helpers/HiringManagerRoute";
import CandidateRoute from "./_helpers/CandidateRoute";
import BaseUrl from "./_helpers/BaseUrlComponent";
import MentorOnboardSuccessful from "./_components/Mentor/MentorOnboardSuccessful";
import MentorRoute from "./_helpers/MentorRoute";
import CreateAssessment from "./_components/Mentor/CreateAssessment";
import CreateAssessmentFinal from "./_components/Mentor/CreateAssessmentFinal";
import ApplicantKanboard from "./_components/Mentor/ApplicantKanboard";
import ViewAppliedJobExtended from "./_components/Mentor/ViewAppliedJobExtended";
import AssignedInterviewKit from "./_components/Candidate/AssignedInterviewKit";
import InterviewInstructions from "./_components/Candidate/InterviewInstructions";
import InterviewScreen from "./_components/Candidate/InterviewScreen";
import InterviewSubmitSuccess from "./_components/Candidate/InterviewSubmitSuccess";
import InterviewSubmitReview from "./_components/Candidate/InterviewSubmitReview";
import Notifications from "./_components/Common/Notifications";
import CandidateAppliedJobs from "./_components/Candidate/CandidateAppliedJobs";
import ApppliedJobsExpanded from "./_components/Candidate/ApppliedJobsExpanded";
import CandidateIntro from "./_components/Candidate/CandidateIntro";
import HiringManagerProfile from "./_components/HiringManager/HiringManagerProfile";
import MentorsApplied from "./_components/HiringManager/MentorsApplied";
import HiringManagerAcceptMentor from "./_components/HiringManager/HiringManagerAcceptMentor";
import ScheduleInterview from "./_components/Common/ScheduleInterview";
import CreateEvent from "./_components/Common/Calendar/CreateEvent";
import JoinScheduledEvent from "./_components/Common/JoinScheduledEvent";
import ViewCandidateProfile from "./_components/Common/ViewCandidateProfile";
import EditCandidateProfile from "./_components/Candidate/EditCandidateProfile";
import EditMentorProfile from "./_components/Mentor/EditMentorProfile";
import AssignedAssessmentKitsList from "./_components/Candidate/AssignedAssessmentKitsList";
import MentorDashboardNew from "./_components/Mentor/MentorDashboardNew";
import HiringManagerDashboardNew from "./_components/HiringManager/HiringManagerDashboardNew";
import MentorAssessmentKits from "./_components/Mentor/MentorAssessmentKits";
import MentorAppliedJobBoard from "./_components/Mentor/MentorAppliedJobBoard";
import HiringManagerJobs from "./_components/HiringManager/HiringManagerJobs";
import CandidateProfile2 from "./_components/Candidate/CandidateProfile2";
import ViewSharedJobDetail from "./_components/Common/ViewSharedJobDetail";
import MentorPublicProfile from "./_components/Common/MentorPublicProfile";
import MentorProfile from "./_components/Mentor/MentorProfile";
import ViewMentorProfile from "./_components/HiringManager/ViewMentorProfile";
import SubmittedCandidatesAssessments from "./_components/Mentor/SubmittedCandidatesAssessments";
import AllMentors from "./_components/HiringManager/AllMentors";
import AllCandidates from "./_components/HiringManager/AllCandidates";
import ViewInterviewVideo from "./_components/Common/ViewInterviewVideo";
import JobOfferTerms from "./_components/Candidate/JobOfferTerms";
import ViewCompanies from "./_components/Common/ViewCompanies";
import Company from "./_components/Common/Company";
import AllAppliedMentor from "./_components/HiringManager/AllAppliedMentor";
import AllAppliedCandidate from "./_components/HiringManager/AllAppliedCandidate";
import JobBoard from "./_components/Common/JobBoard";
import JobBoardExpanded from "./_components/Common/JobBoardExpanded";
import MentorQuestions from "./_components/Common/MentorQuestions";
import AnswerQuestions from "./_components/Common/AnswerQuestion";
import NewCreateAssessment from "./_components/Mentor/NewCreateAssessment";
import CreateAssessmentKitTopic from "./_components/Mentor/CreateAssessmentKitTopic";
// import RecruiterDashboard from "./_components/Recruiter/RecruiterDashboard";
import RecruiterRoute from "./_helpers/RecruiterRoute";
import InvitePasswordReset from "./_components/Common/InvitePasswordReset";
import JobDashboard from "./_components/Common/JobDashboard";
import PrivacyPolicy from "./_components/Common/PrivacyPolicy";
import TermsAndConditions from "./_components/Common/TermsAndConditions";
import CandidateSuggestedJobs from "./_components/Candidate/CandidateSuggestedJobs";
import CandidateJobInvites from "./_components/Candidate/CandidateJobInvites/";
import ViewJobInvite from "./_components/Candidate/ViewJobInvite/ViewJobInvite";
import LandingLeadPage from "./_components/LandingLeadPage";
import AssementKitDetails from "./_components/Common/AssementKitDetails";
import SharedBucketList from "./_components/HiringManager/SharedBucketList";
import BucketListView from "./_components/Mentor/BucketListView";
import ViewBucketList from "./_components/Mentor/ViewBucketList";
import BucketDetail from "./_components/HiringManager/BucketDetail";
import ShortListedCandidateAssessment from "./_components/HiringManager/ShortListedCandidateAssessment";
import HiringManagerPasswordReset from "./_components/HiringManager/HiringManagerPasswordReset";
import EmployerLandingLeadPage from "./_components/EmployerLandingLeadPage";
import MentorLandingLeadPage from "./_components/MentorLandingLeadPage";
import ViewJobDetail from "./_components/Common/ViewJobDetail";
import SignUpMentor from "./_components/Common/SignUpMentor";
import MentorVerification from "./_components/Mentor/MentorVerification";
import MentorVerificationPending from "./_components/Mentor/MentorVerificationPending";
import CreateAssessmentKit from "./_components/Mentor/Assessment/CreateAssessmentKit";
import Calendar from "./_components/Common/Calendar";
import HiringPipeline from "./_components/Common/HiringPipeline";
import WatcherDashBoard from "./_components/Watcher/WatcherDashBoard";
import Watcherkanban from "./_components/Watcher/Watcherkanban";
import SignUpHiringManager from "./_components/Common/SignUpHiringManager";
import AssessmentList from "./screens/assessmentKits/AssessmentList";
import UserCreateAssessmentKit from "./screens/assessmentKits/CreateAssessment";
import PublicAssessmentDetails from "./screens/assessmentKits/PublicAssessmentDetails";
import AssignedAssessments from "./screens/assessmentKits/AssignedAssessments";
import ViewAssessmentResponse from "./screens/assessmentKits/ViewAssessmentResponse";
import TakeAssessmentInstructions from "./screens/assessmentKits/TakeAssessmentInstructions";
import TakeAssessment from "./screens/assessmentKits/TakeAssessment";
import { appRoutes } from "./_routes/app-routes";
import ViewAssessmentCandidates from "./screens/assessmentKits/ViewAssessmentCandidates";
import AssignedAssesssmentDetail from "./screens/assessmentKits/AssignedAssesssmentDetail";
import MentorDashboard from "./screens/Dashboard/MentorDashboard";
import RecruiterDashboard from "./screens/Dashboard/RecruiterDashboard";
import CandidateDashboard from "./screens/Dashboard/CandidateDashboard";
import HiringManagerDashboard from "./screens/Dashboard/HiringManagerDashboard";
function App() {
  React.useEffect(() => {
    // mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
    OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: true,
    }).then(() => {
      OneSignal.showSlidedownPrompt();
      OneSignal.on("notificationDisplay", function (event) {
        const args = {
          message: "New Notification",
          description: event.content,
          duration: 4.5,
        };
        notification.open(args);
      });
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/dashboard"
          element={
            user_token === null ? (
              <SignIn />
            ) : user_token.user.role === null ? (
              <RoleSelection />
            ) : (
              <BaseUrl />
            )
          }
        />
        <Route path="/" element={<EmployerLandingLeadPage />} />
        <Route path="*" element={<Navigate replace to="/" />} />
        <Route
          path="/scheduled-interview/join-new-event/:eventId/:id/"
          element={<JoinScheduledEvent />}
        />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route
          path="password-reset-confirm/:uid/:token/"
          element={<ResetPassword />}
        />

        <Route
          path="view-candidate-profile/:id"
          element={<ViewCandidateProfile />}
        />
        <Route path="view-assessment-video" element={<ViewAssessmentVideo />} />
        <Route
          path="view-interview-video/:hms_room_id/"
          element={<ViewInterviewVideo />}
        />
        <Route path="job-board" element={<JobBoard />} />
        <Route path="job-board-expanded" element={<JobBoardExpanded />} />
        <Route path="view-job-detail/:id" element={<ViewJobDetail />} />
        <Route
          path="invite-password-reset/:uid/:token/"
          element={<InvitePasswordReset />}
        />
        <Route path="view-bucket-detail/:id" element={<BucketDetail />} />
        <Route
          path="hm-reset-password/:uid/:token/"
          element={<HiringManagerPasswordReset />}
        />
        <Route
          path="view-shared-job-detail/:id"
          element={<ViewSharedJobDetail />}
        />
        <Route path="/candidates" element={<LandingLeadPage />} />
        <Route path="/mentors" element={<MentorLandingLeadPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="landing-lead-page" element={<LandingLeadPage />} />
        <Route
          path="view-assessment-kit/:id"
          element={<AssementKitDetails />}
        />
        <Route
          path="candidate-invited-jobs"
          element={<CandidateJobInvites />}
        />
        <Route
          path={appRoutes.assessementKit.assessmentPublicDetails}
          element={<PublicAssessmentDetails />}
        />
        <Route path="/" element={<PublicRoute />}>
          <Route path="sign-in" element={<SignIn />} />
          <Route path="sign-up" element={<SignUp />} />
          <Route path="role-selection" element={<RoleSelection />} />
          <Route path="mentor-sign-up" element={<SignUpMentor />} />
          <Route path="employer-sign-up" element={<SignUpHiringManager />} />
        </Route>

        <Route path="/" element={<PrivateRoute />}>
          <Route path="calender-dashboard" element={<Calendar />} />
          <Route path="create-event" element={<CreateEvent />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="companies" element={<ViewCompanies />} />
          <Route path="company-info/:id" element={<Company />} />
          <Route path="all-candidates" element={<AllCandidates />} />
          <Route path="schedule-interview" element={<ScheduleInterview />} />

          {/* assessment kits */}
          <Route
            path={appRoutes.assessementKit.createAssessment}
            element={<UserCreateAssessmentKit />}
          />
          <Route
            path={appRoutes.assessementKit.viewAssessment}
            element={<UserCreateAssessmentKit />}
          />
          <Route
            path={appRoutes.assessementKit.allAssessments}
            element={<AssessmentList />}
          />
          <Route
            path={appRoutes.assessementKit.viewCandidates}
            element={<ViewAssessmentCandidates />}
          />

          <Route
            path={appRoutes.assessementKit.candidateAssignedAssessments}
            element={<AssignedAssessments />}
          />
          <Route
            path={appRoutes.assessementKit.candidateAssessmentView}
            element={<ViewAssessmentResponse />}
          />

          <Route
            path="mentor-verification-pending"
            element={<MentorVerificationPending />}
          />
          <Route path="mentor-onboard" element={<MentorVerification />} />
          <Route
            path="all-applied-candidates"
            element={<AllAppliedCandidate />}
          />
          <Route path="create-test-question" element={<MentorQuestions />} />
          <Route path="answer-question/:id" element={<AnswerQuestions />} />
          <Route path="job-dashboard" element={<JobDashboard />} />
          {/* hiring manager routes */}
          <Route path="/" element={<HiringManagerRoute />}>
            <Route
              path="hiring-manager-onboard"
              element={<HiringManagerOnboard />}
            />
            <Route
              path="hiring-manager-onboard-success"
              element={<HiringManagerOnboardSuccesful />}
            />
            <Route
              path="hiring-manager-kanboard/:id"
              element={<HiringManagerKanboard />}
            />
            <Route path="create-job" element={<HiringManagerCreateJob />} />
            <Route path="create-job/:id" element={<HiringManagerCreateJob />} />
            <Route
              path="applicant-profile-dashboard/:id"
              element={<HiringProcessDashboard />}
            />
            <Route
              path="hiring-manager-profile"
              element={<HiringManagerProfile />}
            />
            <Route
              path="view-mentors-applied/:id"
              element={<MentorsApplied />}
            />
            <Route
              path="mentor-applied-notification-accept"
              element={<HiringManagerAcceptMentor />}
            />
            <Route
              path="view-mentor-profile/:id"
              element={<ViewMentorProfile />}
            />
            <Route
              path="hiring-manager-dashboard"
              element={<HiringManagerDashboardNew />}
            />
            <Route path="hiring-manager-jobs" element={<HiringManagerJobs />} />
            <Route path="all-mentors" element={<AllMentors />} />
            <Route path="all-applied-mentors" element={<AllAppliedMentor />} />
            <Route
              path="all-applied-candidates"
              element={<AllAppliedCandidate />}
            />
            <Route path="shared-bucket-list" element={<SharedBucketList />} />

            <Route
              path="shortlisted-candidates-assessments/:id"
              element={<ShortListedCandidateAssessment />}
            />
            <Route
              path="dashboard/hiring-manager"
              element={<HiringManagerDashboard />}
            />
          </Route>
          {/* candidate routes */}
          <Route path="/" element={<CandidateRoute />}>
            <Route
              path="candidate-dashboard"
              element={<CandidateDashboard />}
            />
            <Route path="candidate-details" element={<CandidateDetails />} />
            <Route
              path="candidate-onboard-success"
              element={<CandidateOnboardSuccessful />}
            />
            <Route
              path="assigned-interview-kit"
              element={<AssignedInterviewKit />}
            />
            <Route
              path="interview-instructions"
              element={<InterviewInstructions />}
            />
            <Route path="interview" element={<InterviewScreen />} />
            <Route
              path="interview-success"
              element={<InterviewSubmitSuccess />}
            />
            <Route
              path="interview-submit-review"
              element={<InterviewSubmitReview />}
            />
            <Route path="candidate-intro" element={<CandidateIntro />} />
            <Route path="candidate-profile" element={<CandidateProfile2 />} />
            <Route path="all-applied-jobs" element={<CandidateAppliedJobs />} />
            <Route
              path="applied-jobs-expanded"
              element={<ApppliedJobsExpanded />}
            />
            <Route
              path="edit-candidate-profile"
              element={<EditCandidateProfile />}
            />
            <Route
              path="assigned-assessment-kits"
              element={<AssignedAssessmentKitsList />}
            />
            <Route
              path="job-offered/offer-terms/:jobId"
              element={<JobOfferTerms />}
            />
            <Route
              path="candidate-suggested-jobs"
              element={<CandidateSuggestedJobs />}
            />
            <Route path="/view-invite/:id" element={<ViewJobInvite />} />
            <Route
              path={appRoutes.assessementKit.previewAssessment}
              element={<TakeAssessmentInstructions />}
            />
            <Route
              path={appRoutes.assessementKit.takeAssessment}
              element={<TakeAssessment />}
            />
            
            <Route
              path={appRoutes.assessementKit.assignedAssessmentDetail}
              element={<AssignedAssesssmentDetail />}
            />
              <Route
              path="dashboard/candidate" 
              element={<CandidateDashboard />}
            />
          </Route>
          {/* mentor routes */}
          <Route path="/" element={<MentorRoute />}>
            {/* <Route path="mentor-onboard" element={<MentorOnboard />} /> */}
            <Route
              path="assessment/create-assessment"
              element={<CreateAssessmentKit />}
            />
            <Route
              path="mentor-onboard-success"
              element={<MentorOnboardSuccessful />}
            />
            <Route path="create-interview" element={<CreateAssessment />} />
            <Route path="create-interview/:id" element={<CreateAssessment />} />
            <Route
              path="preview-interview-kit/:id"
              element={<CreateAssessmentFinal />}
            />
            <Route path="mentor-kanboard/:id" element={<ApplicantKanboard />} />
            <Route
              path="view-applied-job"
              element={<ViewAppliedJobExtended />}
            />
            <Route
              path="view-applicant-profile-dashboard/:id"
              element={<HiringProcessDashboard />}
            />
            <Route path="mentor-profile" element={<MentorProfile />} />
            <Route path="mentor-dashboard" element={<MentorDashboardNew />} />
            <Route
              path="mentor-assessment-kits"
              element={<MentorAssessmentKits />}
            />
            <Route
              path="mentor-applied-job-board"
              element={<MentorAppliedJobBoard />}
            />
            <Route
              path="submitted-candidates-assessments/:id"
              element={<SubmittedCandidatesAssessments />}
            />
            <Route path="bucket-list" element={<BucketListView />} />
            <Route path="view-bucket-list/:id" element={<ViewBucketList />} />
          </Route>
          <Route path="mentor-profile/:id" element={<MentorPublicProfile />} />
          <Route path="create-assessment" element={<NewCreateAssessment />} />
          <Route
            path="create-assessment/:id"
            element={<NewCreateAssessment />}
          />
          <Route
            path="create-assessment-kit-topic/:assessmentId/"
            element={<CreateAssessmentKitTopic />}
          />
          <Route
            path="create-assessment-kit-topic/:assessmentId/:topicId"
            element={<CreateAssessmentKitTopic />}
          />
          <Route path="hiring-pipeline" element={<HiringPipeline />} />
          <Route path="create-event/:id" element={<CreateEvent />} />
          <Route path="dashboard/mentor" element={<MentorDashboard />} />
        </Route>

        <Route path="/" element={<RecruiterRoute />}>
          <Route path="recruiter-dashboard" element={<RecruiterDashboard />} />
          <Route path="dashboard/recruiter" element={<RecruiterDashboard />} />
        </Route>
        <Route path="edit-mentor-profile" element={<EditMentorProfile />} />
        <Route path="watcher-dashboard" element={<WatcherDashBoard />} />
        <Route path="watcher-kanban" element={<Watcherkanban />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
